<template>
  <div id="app" class="xer-application-content">
    <!-- TO-IMPLEMENT class xer-application-content kan problemen geven en mag weggewerkt worden (niet dringend)-->
    <oeps
      v-if="rootStore.error"
      :error-component="rootStore.error.component"
      :error-component-props="rootStore.error.props"
    />
    <router-view v-else />

    <xer-notification />
  </div>
</template>
<script>
import XerNotification from '@/components/XerNotification';
import Oeps from '@/views/Oeps';
import { mapStores } from 'pinia';
import { useRootStore } from '@/stores';

export default {
  components: {
    XerNotification,
    Oeps
  },
  computed: {
    ...mapStores(useRootStore)
  }
};
</script>
